import React from 'react';
import { toast } from 'react-hot-toast';

/**
 * 💬 Vazifa izohlari (Jamoa F2, 2026-09-25) — jamoa a'zolari o'rtasidagi muhokama.
 * `@username` → o'sha a'zoga push + Telegram; vazifa muallifi ham xabar oladi.
 * Izohlar agentga BERILMAYDI (agentga ko'rsatma — vazifa yoki reja izohi).
 * Ochiq turganda 15s da yangilanadi. `authFetch` effekt dep'iga qo'yilmaydi (ref).
 */
const fmt = (v) => {
  const d = new Date(v);
  if (isNaN(d)) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export default function TaskComments({ authFetch, apiUrl, taskId, count = 0 }) {
  const fetchRef = React.useRef(authFetch);
  fetchRef.current = authFetch;
  const [open, setOpen] = React.useState(false);
  const [rows, setRows] = React.useState(null);
  const [text, setText] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  const load = React.useCallback(async () => {
    try {
      const r = await fetchRef.current(`${apiUrl}/tasks/${taskId}/comments`);
      if (r.ok) setRows(await r.json());
    } catch (e) { /* keyingi urinishda */ }
  }, [apiUrl, taskId]);

  React.useEffect(() => {
    if (!open) return undefined;
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 15000);
    return () => clearInterval(t);
  }, [open, load]);

  const send = async () => {
    const body = text.trim();
    if (!body) return;
    setBusy(true);
    try {
      const r = await fetchRef.current(`${apiUrl}/tasks/${taskId}/comments`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ body }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Yuborilmadi');
      setText('');
      if (d.notified) toast.success(`💬 Yuborildi — ${d.notified} kishiga xabar ketdi`);
      await load();
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };

  const del = async (id) => {
    if (!window.confirm("Izoh o'chirilsinmi?")) return;
    try {
      const r = await fetchRef.current(`${apiUrl}/tasks/${taskId}/comments/${id}`, { method: 'DELETE' });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || "O'chirilmadi");
      await load();
    } catch (e) { toast.error(e.message); }
  };

  const n = rows ? rows.length : Number(count) || 0;
  return (
    <div className="mt-2">
      <button type="button" onClick={() => setOpen(v => !v)}
        className="text-[11px] text-gray-500 dark:text-gray-400 hover:text-primary-700 dark:hover:text-primary-300">
        💬 Izohlar{n ? ` (${n})` : ''} {open ? '▾' : '▸'}
      </button>
      {open && (
        <div className="mt-1.5 border-l-2 border-gray-100 dark:border-gray-700 pl-3 space-y-2">
          {rows === null && <div className="text-xs text-gray-400">⏳</div>}
          {rows && rows.length === 0 && <div className="text-xs text-gray-400">Hali izoh yo'q. Jamoadoshni @username bilan eslating.</div>}
          {(rows || []).map(c => (
            <div key={c.id} className="text-xs">
              <div className="flex items-center gap-2 text-gray-400">
                <span className="font-semibold text-gray-700 dark:text-gray-200" translate="no">{c.username || '—'}</span>
                <span>{fmt(c.created_at)}</span>
                {c.mine && <button type="button" onClick={() => del(c.id)} className="hover:text-red-500">✕</button>}
              </div>
              <div className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap break-words" translate="no">{c.body}</div>
            </div>
          ))}
          <div className="flex gap-2 items-end">
            <textarea value={text} onChange={e => setText(e.target.value)} rows={2}
              onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) send(); }}
              placeholder="Izoh… (@username — eslatish, ⌘/Ctrl+Enter — yuborish)"
              className="flex-1 min-w-0 text-xs border border-gray-200 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 rounded-lg px-2.5 py-1.5 focus:outline-none focus:ring-2 focus:ring-primary-300" />
            <button type="button" onClick={send} disabled={busy || !text.trim()}
              className="px-3 py-1.5 text-xs font-semibold bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50">
              {busy ? '⏳' : 'Yuborish'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
